var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    stroke: "#596B7C",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7568 11.675H6.57623C5.6941 11.675 4.979 12.4137 4.979 13.325V19.1C4.979 20.0113 5.6941 20.75 6.57623 20.75H17.7568C18.6389 20.75 19.354 20.0113 19.354 19.1V13.325C19.354 12.4137 18.6389 11.675 17.7568 11.675Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17334 11.675V8.375C8.17334 7.28098 8.59404 6.23177 9.34288 5.45818C10.0917 4.6846 11.1074 4.25 12.1664 4.25C13.2254 4.25 14.2411 4.6846 14.9899 5.45818C15.7388 6.23177 16.1595 7.28098 16.1595 8.375V11.675",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.dc97de5bf2263feebca0126a6a148043.svg";
export { ForwardRef as ReactComponent };